import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {useIsMultiBrand, useSrtParam} from '@aboutyou/router';
import {
  useBasketTokenAwaitedAnySession,
  useNavigationBackOptimizedBasketToken,
} from '@aboutyou/user';
import {
  getPagination,
  labelToSortingOption,
} from '../../../../features/ProductStream/helpers';
import {
  useAppliedLiveAtFilter,
  useAppliedPotentialFilters,
  useKeepPreviousData,
  useResetOnFetchEnd,
  useSorting,
} from '../../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useFirstProductIds} from '../../../../features/firstProductId/useFirstProductIds';
import {useCategoryIdentifier} from '../../../../features/hooks/useCategoryIdentifier';
import {useProtoProductImageType} from '../../../../shared-deprecated/useProductImageType';
import {useTargetGroupIdentifier} from '../../../../shared-deprecated/useTargetGroupIdentifier';
import {
  useBrandShopCacheKeyTransformer,
  useBrandShopIdentifier,
} from '../../utils/useBrandShopIdentifier';
// eslint-disable-next-line jest/no-mocks-import
import {BrandHubPageService_GetStreamLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.grpc.lazy';
import {useActivateSortingAbTest} from '../../../../client-services/SortingAbTestFramework/useActivateSortingAbTest';

export const useBrandPageStream = () => {
  const {sorting} = useSorting();

  const {basketToken} = useNavigationBackOptimizedBasketToken({
    uniqueKey: 'brand_page_stream',
  });
  const {session, refetchesDisabled} = useBasketTokenAwaitedAnySession();
  const brandIdentifier = useBrandShopIdentifier();
  const targetGroup = useTargetGroupIdentifier();
  const {keepPreviousData, resetOnFetchEnd} = useKeepPreviousData();
  const isMultiBrand = useIsMultiBrand();
  const brandShopCacheKeyTransformer = useBrandShopCacheKeyTransformer();
  const appliedFilters = useAppliedPotentialFilters();
  const liveAtFilter = useAppliedLiveAtFilter();
  const category = useCategoryIdentifier();
  const firstProductIds = useFirstProductIds();
  const sortingChannel = useSrtParam();

  const preferredImage = useProtoProductImageType();

  const activateSortingAbTest = useActivateSortingAbTest();

  const request = useGrpcRequest(
    BrandHubPageService_GetStreamLazy,
    {
      session,
      targetGroup,
      brand: {
        identifier: brandIdentifier,
      },
      appliedFilters: {
        filters: appliedFilters,
        liveAt: liveAtFilter
          ? {
              minDate: liveAtFilter,
            }
          : undefined,
      },
      category: category ?? null,

      pagination: getPagination(1),
      isMultiBrand,
      enableFitmatch: false,
      enableAiuta: false,
      sortOptions: labelToSortingOption(sorting),
      reductionsState: useReductionsStateRequestParameter(),
      firstProductIds,
      basketToken,
      preferredProductImageType: preferredImage,
      sortingChannel,
    },
    {
      transformCacheKey: brandShopCacheKeyTransformer,
      disabled: refetchesDisabled,
      keepPreviousData,
      retry: 1,
      onSuccess: activateSortingAbTest,
    },
  );

  useResetOnFetchEnd(request, resetOnFetchEnd);

  return request;
};
